import { isNil } from 'lodash';
import gameConfig from './gameConfig';
import getQueryParam from './queryParam';
import translations from '../translations/en';
import toBoolean from './toBoolean';

const company = getQueryParam('company') || getQueryParam('companyUuid') || 'b99752b3-443c-4c80-b559-945a95c4b805';
const language = getQueryParam('lang') || getQueryParam('language') || 'en';
const deliveryPlatform = getQueryParam('deliveryPlatform') || getQueryParam('deliveryChannel') || 'web';
const environment = getQueryParam('env') || getQueryParam('environment') || 'staging';
const server = getQueryParam('server') || getQueryParam('serverUrl');
// '9830bc82-3cac-44de-94a5-c4df51dadf20' Loki
// 'e82378b4-5577-4972-8882-74dbe47ec957' PF
const channel = getQueryParam('channel') || getQueryParam('cpvUuid') || '79bbfe91-4524-4d76-a25a-df3560c2dcff';
const streamToken = getQueryParam('streamToken');
const appMode = getQueryParam('appMode') || 'default'; // default, stream-player or stream-runner
const showcaseLoop = toBoolean(getQueryParam('showcaseLoop'));
const videosPath = getQueryParam('videosPath');
const bgVideo = toBoolean(getQueryParam('bgVideo'));
const dataMock = toBoolean(getQueryParam('dataMock'));
const debug = toBoolean(getQueryParam('debug') || getQueryParam('debugMode'));

export default {
  app: {
    companyLanguage: false,
    lastCountdownTime: 5,
    videoFormat: 'mp4',
    logo: {
      enabled: false,
      path: null,
      useDefault: false,
      image: {
        preferredSize: {
          width: 150,
          height: 25,
        },
        offset: {
          x: 10,
          y: 0,
        },
      },
    },
    game: gameConfig,
    stream: {
      name: 'virtual-drag-races',
      origin: {
        dev: '://stream-dev.7platform.live',
        staging: '://stream-staging.7platform.live',
        production: '://stream.7platform.live',
      },
      tokenPath: '/web/streaming/generate-token.json',
      sources: [
        {
          protocol: 'https',
          type: 'application/x-mpegURL',
          path: '/{company}/{streamName}.m3u8?token={token}&page={page}',
        },
        {
          protocol: 'https',
          type: 'application/dash+xml',
          path: '/{company}/{streamName}.mpd?token={token}&page={page}',
        },
        {
          protocol: 'rtmp',
          type: 'rtmp/mp4',
          path: '/{company}?token={token}/{streamName}',
        },
      ],
      resolution: {
        low: '240p',
        medium: '480p',
        high: '720p',
      },
    },
    showcaseLoop: !isNil(showcaseLoop) ? showcaseLoop : true,
    videosPath: !isNil(videosPath) ? videosPath : 'file:///opt/virtual-drag-races-videos/',
    bgVideo: !isNil(bgVideo) ? bgVideo : true,
    dataMock: !isNil(dataMock) ? dataMock : false,
    debug: !isNil(debug) ? debug : false,
    mode: appMode,
    translations,
    language,
  },
  platform: {
    uuid: '00301e05-af1a-4cd3-8690-3ff5c362aa72',
    token: 'token',
    clientType: 'user',
    clientSubType: 'Player',
    encoding: {
      default: 'plaintext',
    },
  },
  product: {
    name: 'VirtualDragRaces',
    title: 'Virtual Drag Races',
    server,
    environment,
    deliveryPlatform,
    streamToken,
    channel,
    company,
  },
};
